import { format } from "date-fns";

interface StatsFooterProps {
  joinedAt: string | Date | null | undefined;
  totalSessions: number | null;
  projectsCompleted: number | null;
}

export function StatsFooter({ joinedAt, totalSessions, projectsCompleted }: StatsFooterProps) {
  const joinedFormatted = joinedAt
    ? format(new Date(joinedAt), "MMMM yyyy")
    : "—";

  const sep = <span className="mx-1 opacity-40">·</span>;

  return (
    <div
      data-testid="stats-footer"
      className="border-t pt-4 text-xs text-muted-foreground"
    >
      <span>Joined: {joinedFormatted}</span>
      {sep}
      <span>Total sessions: {totalSessions ?? "—"}</span>
      {sep}
      <span>Projects completed: {projectsCompleted ?? "—"}</span>
    </div>
  );
}
